import template from "./pCasemanMatch.html";

export function pCasemanMatchDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: pCasemanMatchController,
    controllerAs: 'pCasemanMatch',
    bindToController: true
  };

  return directive;
}

class pCasemanMatchController {
  constructor($scope, $location, $interval, Auth, Caseman, Notes, Sort, ConnectionQuality) {
    'ngInject';
    this.$scope = $scope;
    this.$location = $location;
    this.$interval = $interval;
    this.Auth = Auth;
    this.Caseman = Caseman;
    this.Sort = Sort;
    this.Notes = Notes;
    this.ConnectionQuality = ConnectionQuality;
    this.state = "loading";

    this.headers = [
      {name: "CASEMAN.CLIENT", class: null},
    ];

    this.Auth.authorize().then(
      (user) => {
        this.user = user;
        this.hasErpProjectsFlag = !!user.preferences.featureFlags.find(ff => ff === "ProjectsFromErpSystem");
        //Notes...
        const timeout = this.$interval(() => { this.notes = this.Notes.getNotes();}, 200);
        this.$scope.$on("$destroy", () => {this.$interval.cancel( timeout );});

        this.Caseman.getIntegrationStrategy().then(
          (success) => {
            this.customizationType = success.data.worklogMappersCustomization;

            if (this.customizationType === 'User') {
              this.Caseman.getUserClients(this.user.id).then(
                (success) => {
                  this.clients = success.data.data.map(c => {
                    if (c.additionalInfo) {
                      c.nameWithAdditionalInfo = `(${c.additionalInfo}) ${c.name}`;
                    }

                    return {...c, projects: c.projects.filter(p => p.status === "Active") };
                  }).sort(this.Sort.abcBy("name"));
                  this.state = "loaded";

                },
                (error) => {
                  this.state = "error";
                  this.Notes.postNote({type: "error", error: error});
                }
              );
              this.selectedUser = this.user;

              if(this.user.isIntegrationAdmin){
                this.setUsers = this.Caseman.getUsersByCountryKlix();
              } else if(this.user.role == "TeamLeader" || this.user.role == "DeputyTeamLeader"){
                this.setUsers = this.Caseman.getUsersByTeamKlix();
              }

              if(this.user.isIntegrationAdmin || this.user.role == "TeamLeader" || this.user.role == "DeputyTeamLeader") {
                this.setUsers.then(
                  (success) => {
                    this.usersKlix = success.data.sort(this.Sort.abcBy('fullName'));
                  },
                  (error) => {
                    this.state = "error";
                    this.Notes.postNote({type: "error", error: error});
                  }
                );
              }
            } else {
              this.getClientsForTeam(this.user.teamId);

              this.Caseman.getTeams().then(
                (success) => {
                  this.teams = success.data;
                  this.selectedTeam = this.teams.find(team => team.id === this.user.teamId);
                },
                (error) => {
                  this.state = "error";
                  this.Notes.postNote({type: "error", error: error});
                }
              );
            }

          },
          (error) => {
            this.state = "error";
            this.Notes.postNote({type: "error", error: error});
          }
        );
      },
      () => {
        this.Auth.handleUnauthorized();
      }
    );

    $scope.$on('connectionQualityChanged', () => {
      if (this.ConnectionQuality.isSlow) {
        this.Notes.postNote({
          type: 'slowConnection',
          manualHide: true
        });
      }
      else {
        const note = this.Notes.getNotes().find(note => note.type === 'slowConnection' && note.active);
        if (note)
          this.Notes.hide(note);
      }
    });
  }

  openProcesses(client, user) {
    const matchingOrCustomizing = this.hasErpProjectsFlag ? 'customize' : 'matching';
    if (this.customizationType === 'User') {
      this.$location.path(`/caseman/${matchingOrCustomizing}/client/${client.id}/user/${user.id}/name/${user.fullName}`);
    } else {
      this.$location.path(`/caseman/${matchingOrCustomizing}/client/${client.id}/team/${this.selectedTeam.id}/name/${this.selectedTeam.name}`);
    }
  }

  openProjectProcesses(client, user, project) {
    // console.log('user', user)
    const matchingOrCustomizing = this.hasErpProjectsFlag ? 'customize' : 'matching';

    if (this.customizationType === 'User') {
      this.$location.path(`/caseman/${matchingOrCustomizing}/client/${client.id}/user/${user.id}/name/${user.fullName}/project/${project.id}/projectName/${encodeURI(project.name.replace(/\//g, ''))}`);
    } else {
      this.$location.path(`/caseman/${matchingOrCustomizing}/client/${client.id}/team/${this.selectedTeam.id}/name/${this.selectedTeam.name}/project/${project.id}/projectName/${encodeURI(project.name.replace(/\//g, ''))}`);
    }
    // if (this.hasErpProjectsFlag) {
    //   this.$location.path('/caseman/customize/client/' + client.id + '/user/' + user.id + '/name/' + user.fullName + '/project/' + project.id + '/projectName/' + encodeURI(project.name.replace(/\//g, '')));
    // } else {
    //   this.$location.path('/caseman/matching/client/' + client.id + '/user/' + user.id + '/name/' + user.fullName + '/project/' + project.id + '/projectName/' + encodeURI(project.name.replace(/\//g, '')));
    // }
  }

  getClients(selected) {
    this.state = "loading";
    this.Caseman.getUserClients(selected.id).then(
      (success) => {
        this.clients = success.data.data.map(c => ( {...c, projects: c.projects.filter(p => p.status === "Active") } ) ).sort(this.Sort.abcBy("name"));
        this.state = "loaded";
      },
      (error) => {
        this.state = "error";
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  isProjectEmpty(client){
    return client.projects.length === 0;
  }

  isOneProjectAvailable(client){
    return client.projects.length === 1;
  }

  handleSelectTeam(team) {
    this.getClientsForTeam(team.id);
  }

  getClientsForTeam(id) {
    this.state = "loading";

    this.Caseman.getClientsByTeamId(id).then(
      (success) => {
        this.clients = success.data.map(c => ( {...c, projects: c.projects.filter(p => p.status === "Active") } ) ).sort(this.Sort.abcBy("name"));
        this.state = "loaded";
      },
      (error) => {
        this.state = "error";
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

}
